import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { countUnique, sum } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDate, styleDateRange } from '@utils/styles';

interface CutsByResellerProps {
    dateRange: { startDate: string; endDate: string };
}

export const CutsByReseller = ({ dateRange }: CutsByResellerProps) => {
    const [range, setRange] = useRange('CutsByReseller');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_FOR_DATE_RANGE,
        params: { ...dateRange, range },
    });

    return (
        <BaseReport
            title={'Successful Cuts by Resellers'}
            description={
                'This table shows you the number of cuts performed for the entire date range selected above. Only successful, new sale cuts are measured.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            setRange={setRange}
            range={range}
            tableOptions={{
                headers: ['Date', 'Reseller Name', 'Company Name', 'Successful Cuts'],
                data: data.map((item) => [item.date, item.resellerName, item.companyName, item.successfulCuts]),
                summaries: [countUnique, countUnique, countUnique, sum],
                style: [styleDate(range)],
                sort: [dateSort(range), basicSort, basicSort, basicSort],
            }}
        />
    );
};
